import React from 'react';
export function TableListItem(props) {
  const {
    columnDef,
    item,
    children
  } = props;
  if (!columnDef) return null;
  const {
    width: columnWidth,
    hAlign
  } = columnDef;
  const width = typeof columnWidth === 'number' ? columnWidth : null;
  const minWidth = typeof columnWidth === 'object' ? columnWidth[0] : columnWidth;
  const maxWidth = typeof columnWidth === 'object' ? columnWidth[1] : columnWidth;
  const fluid = minWidth ? 1 : null;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": item['data-testid'] || props['data-testid'],
    className: item.className,
    style: {
      textAlign: hAlign || 'left',
      width,
      minWidth,
      maxWidth,
      flex: fluid
    }
  }, children || item.value);
}